<template>
<div class="chart-div">
    <area-chart :data="chartdata.graphdata" :ytitle="chartdata.ytitle" :xtitle="chartdata.xtitle" :download="{ background: 'white' }"></area-chart>
</div>
</template>

<script>

export default {
    props : ['chartdata'],
    created() {
    },
    data() {
        return {
        };
    },

    computed: {
        // ...mapState({
        //     gdata: state => state.dashboard.subjectgraph
        // })
    }
};
</script>

<style scoped>
.chart-div{
    background-color: white;
    border-radius: 10px 10px;
    padding: 6px;
}
</style>
